import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';
import { AutoText } from '../../../components/pdf/autoText'; 

const styles = StyleSheet.create({
    title: {
      fontSize: 18,
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: 5,
    },
    subtitle: {
      fontSize: 10,
      textAlign: 'center',
      marginBottom: 15,
    },
    sectionTitle: {
      fontSize: 11,
      fontWeight: 'bold',
      marginBottom: 6,
      color: '#000',
    },
    paragraph: {
      fontSize: 10,
      marginBottom: 5,
      lineHeight: 1.4,
    },
    bulletItem: {
      flexDirection: 'row',
      marginBottom: 4,
      gap: 5,
    },
    bulletSymbol: {
      width: 14,
      fontSize: 10,
      fontWeight: 'bold',
      textAlign: 'right',
    },
    bulletText: {
      flex: 1,
      fontSize: 10,
      textAlign: 'justify',
      lineHeight: 1.6,
    },
    fieldLabel: {
      width: '35%',
      fontSize: 10,
      fontWeight: 'bold',
    },
    fieldValue: {
      width: '65%',
      fontSize: 10,
      borderBottom: '0.5px solid #000',
      paddingBottom: 2,
    },
    fieldRow: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      marginBottom: 6,
    },
    divider: {
      borderBottom: '0.7px solid #999',
      marginVertical: 12,
    },
    signatureRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 30,
      fontSize: 9,
    },
    signatureLeft: {
      width: '45%',
    },
    signatureRight: {
      width: '45%',
      textAlign: 'right',
    },
    officeStamp: {
      marginTop: 30,
      fontSize: 10,
      textAlign: 'center',
    },
  });
  

const SrVikalp = ({ result }) => {
  return (
    <View size="A4" style={style.page}> 
      {/* Header */}
      <Text style={[styles.subtitle, style.marathi]}>
        पदोन्नती- कालबद्ध पदोन्नती /वरिष्ठ श्रेणी /निवड श्रेणी करिता द्यावयाचा विकल्पाचा नमुना
      </Text>

      <Text style={[styles.title, style.marathi]}>विकल्प</Text>
      <Text style={[styles.subtitle, style.marathi]}>
        संदर्भ - शासन निर्णय वित्त विभाग क्रमांक पी. ए. वाय.-१०९२/ सी.आर.११०० (एफ)एस.ई.आर. दिनांक ६ नोव्हेंबर १९८४
      </Text>
      
      <View style={styles.divider}></View>

      {/* Section 1 */}
      <Text style={[styles.sectionTitle, style.marathi]}>१.)</Text>
      
      {/* Field rows */}
      <View style={styles.fieldRow}>
        <AutoText style={[styles.fieldLabel, style.marathi]}>अ) कर्मचाऱ्याचे नाव</AutoText>
        <AutoText style={[styles.fieldValue, style.marathi]}>: {result.employeeName}</AutoText>
      </View>
      
      <View style={styles.fieldRow}>
        <AutoText style={[styles.fieldLabel, style.marathi]}>ब) धारण केलेले पद</AutoText>
        <AutoText style={[styles.fieldValue, style.marathi]}>: {result.designation}</AutoText>
      </View>
      
      <View style={styles.fieldRow}>
        <AutoText style={[styles.fieldLabel, style.marathi]}>क) पदोन्नतीचे पद</AutoText>
        <AutoText style={[styles.fieldValue, style.marathi]}>: {result.designation}</AutoText>
      </View>
      
      <View style={styles.fieldRow}>
        <AutoText style={[styles.fieldLabel, style.marathi]}>ड) विद्यमान श्रेणी/ वेतन स्तर</AutoText>
        <AutoText style={[styles.fieldValue, style.marathi]}>: {result.payBandPrevious}</AutoText>
      </View>
      
      <View style={styles.fieldRow}>
        <AutoText style={[styles.fieldLabel, style.marathi]}>इ) पदाची वरिष्ठ वेतनश्रेणी/ स्तर</AutoText>
        <AutoText style={[styles.fieldValue, style.marathi]}>: {result.payBandPromotion}</AutoText>
      </View>
      
      <View style={styles.fieldRow}>
        <AutoText style={[styles.fieldLabel, style.marathi]}>ई) वरिष्ठ वेतनश्रेणी पात्र दिनांक</AutoText>
        <AutoText style={[styles.fieldValue, style.marathi]}>: {result.dateOfPromotion}</AutoText>
      </View>
      
      <View style={styles.fieldRow}>
        <AutoText style={[styles.fieldLabel, style.marathi]}>फ) कार्यालयाचे नाव</AutoText>
        <AutoText style={[styles.fieldValue, style.marathi]}>: {result.officeName}</AutoText>
      </View>

      {/* Section 2 */}
      <Text style={[styles.sectionTitle, style.marathi, { marginTop: 15 }]}>२.) मी,श्री {result.employeeName}</Text>
      
      <View style={styles.bulletItem}>
        <Text style={[styles.bulletSymbol, style.marathi]}>अ)</Text>
        <AutoText style={[styles.bulletText, style.marathi]}>
          वरिष्ठ वेतनश्रेणी पात्र दिनांक {result.dateOfPromotion} पासून वरिष्ठ वेतनश्रेणी/ निवड श्रेणीची निवड करतो /करते.
        </AutoText>
      </View>
      
      <View style={styles.bulletItem}>
        <Text style={[styles.bulletSymbol, style.marathi]}>ब)</Text>
        <AutoText style={[styles.bulletText, style.marathi]}>
          मी धारण करीत असलेल्या पदाची विद्यमान श्रेणी पुढीलप्रमाणे चालू ठेवण्याची निवड करतो /करते
        </AutoText>
      </View>
      
      <View style={[styles.bulletItem, { marginLeft: 15 }]}>
        <Text style={[styles.bulletSymbol, style.marathi]}>*</Text>
        <AutoText style={[styles.bulletText, style.marathi]}>
          माझ्या पुढील वेतनवाढीच्या दि {result.dateOfOption} तारखेपर्यंत
        </AutoText>
      </View>
      
      <View style={[styles.bulletItem, { marginLeft: 15 }]}>
        <Text style={[styles.bulletSymbol, style.marathi]}>*</Text>
        <AutoText style={[styles.bulletText, style.marathi]}>
          माझे वेतन रु.व पर्यंत वाढणाऱ्या माझ्यानंतरच्या वेतनवाढीच्या तारखेपर्यंत
        </AutoText>
      </View>
      
      <View style={[styles.bulletItem, { marginLeft: 15 }]}>
        <Text style={[styles.bulletSymbol, style.marathi]}>*</Text>
        <AutoText style={[styles.bulletText, style.marathi]}>
          माझे पद रिक्त करेपर्यंत किंवा विद्यमान श्रेणीत वेतन घेण्याचे बंद करेपर्यंत
        </AutoText>
      </View>

      {/* Section 3 */}
      <Text style={[styles.sectionTitle, style.marathi, { marginTop: 15 }]}>
        ३) हा विकल्प अंतिम असून त्यामध्ये सुधारणा करण्यात येणार नाही.
      </Text>

      {/* Signature section */}
      <View style={styles.signatureRow}>
        <View style={styles.signatureLeft}>
          <AutoText style={[style.marathi]}>दिनांक:- _________________________</AutoText>
        </View>
        <View style={styles.signatureRight}>
          <AutoText style={[style.marathi]}>सही: _________________________</AutoText>
          <AutoText style={[style.marathi, { marginTop: 5 }]}>नाव: {result.employeeName}</AutoText>
        </View>
      </View>

      <View style={[styles.divider, { marginTop: 30 }]}></View>

      {/* Office section */}
      <Text style={[styles.sectionTitle, style.marathi, { textAlign: 'center' }]}>
        कार्यालयाने भरावयाचे
      </Text>
      
      <AutoText style={[styles.paragraph, style.marathi, { textAlign: 'center', marginTop: 10 }]}>
        प्रमाणित करण्यात ते की कायम / स्थानापन्न पद धारण करत असलेल्या {result.employeeName}, {result.designation} यांनी हा विकल्प यथोचितरित्या स्वाक्षरीसह विहित दिनांकापूर्वी मला सादर केला आहे.
      </AutoText>

      <View style={styles.signatureRow}>
        <View style={styles.signatureLeft}>
          <AutoText style={[style.marathi]}>दिनांक:- _________________________</AutoText>
        </View>
        <View style={styles.signatureRight}>
          <AutoText style={[style.marathi]}>कार्यालयीन प्रमुख</AutoText>
        </View>
      </View>
    </View>
  );
};

export default SrVikalp;